module.exports = __webpack_public_path__ + "static/media/googleicon.d0975f09.svg";